<template>
  <b-sidebar
    v-model="modalOpen"
    v-if="modalOpen"
    centered
    id="branchModal"
    class="edit-modal"
    width="500px"
    backdrop
    no-close-on-backdrop
    no-close-on-esc
    no-header
    body-class="bg-white"
  >
    <div class="p-2">
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col class="d-flex justify-content-between" cols="12">
              <h3> {{ mainTitle }} </h3>
              <feather-icon
                size="20"
                class="cursor-pointer"
                @click="modalOpen = false"
                icon="XIcon"
              />
            </b-col>
            <b-col cols="12">
              <hr />
            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="نوع الفرع"
                v-model="form.branch_type_id"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name_ar"
                ep="v2/selects/branch-types"
                id="branch-types"
                @option:selected="typeInputHandle"
              />
            </b-col>
            <!-- <b-col cols="12">
              <form-select
                label="المحافظة المرخصة"
                v-model="form.licensed_city_id"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="Lgov"
                ep="v2/selects/governorates"
                ref="lgov"
                rules="required"
              />
            </b-col> -->
            <b-col cols="12" class="mb-1 mt-1">
              <span class="text-muted">
                <feather-icon icon="InfoIcon" /> قم بالضغط على رمز الخريطة للبحث
                عن الموقع</span
              >
            </b-col>
            <b-col cols="12" class="d-flex align-items-center">
              <form-input
                readonly
                style="width: 40%"
                rules="required"
                label="خط الطول"
                v-model="form.longitude"
              />
              <form-input
                readonly
                class="mx-50"
                style="width: 40%"
                rules="required"
                label="خط العرض"
                v-model="form.latitude"
              />
              <b-button
                @click="mapModal = true"
                class="btn btn-primary mt-50"
                variant="flat-primary"
              >
                <feather-icon icon="MapPinIcon" />
              </b-button>
            </b-col>
            <!-- <b-col cols="12">
              <form-input
                rules="required"
                label="العنوان التفصيلي"
                v-model="form.address"
                />
            </b-col> -->
            <b-col cols="12">
              <form-select
                label="رقم العقار"
                v-model="form.real_estate_id"
                :getOptionLabel="(x) => x.number"
                :reduce="(x) => x.id"
                id="branhc-real-estate-id"
                ep="v"
                ref="branchRealEstates"
                rules="required"
              />
              <small class="text-muted"
                >تظهر فقط أرقام العقارات للمحافظة التي قمت باختيارها</small
              >
            </b-col>

            <b-col v-if="form.branch_type_id === 1" cols="12">
              <form-mask
                placeholder="YYYY-MM-DD"
                options="date"
                rules="required"
                label="تاريخ قرار الإشهار"
                v-model="form.decision_date"
              />
            </b-col>
            <b-col cols="12">
              <form-textarea
                label="الخدمات المقدمة"
                rows="3"
                v-model="form.services"
                placeholder="وصف عن الخدمة وما تقدمه"
                rules="required"
              />
            </b-col>
            <b-col cols="12">
              <form-textarea
                label="اللجنة الإدارية"
                rows="3"
                v-model="form.management_committee"
                placeholder="أسماء أعضاء اللجنة الإدارية"
                rules="required"
              />
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <b-modal
      v-model="mapModal"
      centered
      size="lg"
      title="موقع الفرع"
      footer-class="removed"
      class="edit-modal"
      id="branchModal"
    >
      <map-select
        @closeModal="mapModal = false"
        @markerUpdated="onLocationSelect"
        :govsEndpoint.sync="govEp"
      />
      <!-- <b-row class="justify-content-end mt-1">
        <b-button @click="mapModal = false">إلغاء</b-button>
        <b-button variant="success" class="mx-1">تأكيد</b-button>
      </b-row> -->
    </b-modal>
  </b-sidebar>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "معلومات فرع",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      required,
      integer,
      govId: null,
      mapModal: false,
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    branchTypes() {
      return this.$store.getters["branch-types/options"];
    },
    govEp() {
      return this.form.branch_type_id &&
        this.branchTypes.find((el) => el.id === this.form.branch_type_id)
          .name_ar === "مكتب"
        ? "v2/selects/branch-related-governorates?related=true"
        : "v2/selects/branch-related-governorates?related=false";
    },
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          this.init(this.intializeForm);
        });
    },
    govId(val) {
      if (val) {
        this.$refs.branchRealEstates.refreshOptions(
          `v2/selects/real-estates?gid=${val}`
        );
        delete this.form.real_estate_id;
      }
    },
    govEp: {
      immediate: true,
      handler(val) {
        if (this.$refs.govs) this.$refs.govs.refreshOptions(val);
      },
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
      if (form.governorate_id) {
        this.govId = form.governorate_id;
        this.form.real_estate_id = form.real_estate_id;
      }
    },
    typeInputHandle(e) {
      this.$delete(this.form, "sub_district_id");
      this.$delete(this.form, "decision_date");
      this.$delete(this.form, "management_committee");
    },
    onLocationSelect(e) {
      this.form.governorate_id = e.govId;
      this.form.longitude = e.pos.lng;
      this.form.latitude = e.pos.lat;
      this.form.sub_district_id = e.area.id;
      this.form.address = e.address;
      this.govId = e.govId;
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>
